import { QuickDepositPopupLauncher } from 'js/components/popups/QuickDepositPopup';

import * as hocs from '../../hocs';

export const QuickDepositPage = hocs.withCommonPage(QuickDepositPopupLauncher, true);
